import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { OrderHistoryInfo } from '../types';
import { PATHS } from '../utils';

const getAllOrders = async (
  authorization: string,
  storeid:string,
  groupName :string
): Promise<OrderHistoryInfo[]> => {
  const response = await apiHandler({
    url: PATHS.GET_ORDERS,
    method: METHOD.GET,
    qsObject: {
        storeId:storeid,
        groupName:groupName
      },
    headers: { authorization },
  });
  if (!response.ok) throw new Error(response.statusText);

  return (await response.json()) as Promise<OrderHistoryInfo[]>;
};

export default getAllOrders;